import React from "react";
import IcClose from "../../../../../../../../../../../../../../../Assets/Icons/close-outline-white.svg";
import "./MarketplaceHeader.scss";

const MarketplaceHeader = ({ onClose }) => {
  return (
    <div className="marketplace__container--header">
      <span className="title">Shops Near You</span>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          color: "white",
        }}
      >
        Close
        <img src={IcClose} onClick={onClose} alt="icon" className="icon" />
      </div>
    </div>
  );
};

export default MarketplaceHeader;
